module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-upload",
    on: {
      "click": _vm.openFileSelector
    }
  }, [(!_vm.url) ? [(!_vm.percent) ? _c('i', {
    staticClass: "add-icon"
  }) : _c('span', {
    staticClass: "upload-percent"
  }, [_vm._v(_vm._s(_vm.percent) + "%")])] : [_c('img', {
    staticClass: "preview-img",
    attrs: {
      "src": _vm.url
    }
  })], _vm._v(" "), _c('input', {
    ref: "input",
    staticClass: "upload-input",
    attrs: {
      "type": "file"
    },
    on: {
      "change": _vm.handleChange
    }
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-09fbfd97","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/public-lib/vue-components/src/components/c-upload/index.vue
// module id = 348
// module chunks = 0